import { Button, Form } from 'react-bootstrap';

/**
 * A stylized button for the user editor pages. Submit + Admin buttons.
 * @param {{onSubmit: (), onAdmin: (value: boolean), isAdmin: boolean, disabled: boolean, title?: string}}
 * @returns
 */
export default function UserEditSubmitButton({
  onSubmit,
  onAdmin = () => {},
  isAdmin,
  disabled,
  title = 'Create User',
}) {
  return (
    <div className={`d-flex flex-column flex-column-reverse flex-sm-row gap-sm-3 gap-2 h-100`}>
      <div
        className={`d-flex gap-1 justify-content-center justify-content-sm-end align-items-center`}
      >
        <div>User is an Admin </div>
        <Form.Check type="checkbox" checked={isAdmin} onChange={(e) => onAdmin(e.target.checked)} />
      </div>
      <Button variant="primary" disabled={disabled} className={`p-3 h-100`} onClick={onSubmit}>
        {title}
      </Button>
    </div>
  );
}
